/* MySpirulina, Anbau-Garantie
   Legt die Anbau-Garantie automatisch in den Warenkorb, sobald das Starter-Kit
   darin liegt, und entfernt sie wieder, sobald das Starter-Kit fehlt.

   Reihenfolge: die Garantie wird bewusst VOR dem Starter-Kit angelegt, weil der
   Shopify-Checkout die zuletzt angelegte Zeile oben anzeigt. So steht im Checkout
   das Starter-Kit oben und die Garantie darunter. Im Warenkorb und im Drawer
   schiebt das Skript die Garantie zusaetzlich per DOM direkt unter das Starter-Kit.

   Das Produkt ist Unlisted, zusaetzlich werden hier die Links aus der
   Warenkorbzeile entfernt, damit niemand auf die Produktseite kommt.

   Starter-Kit-Zeile: bekommt die Klasse ms-kit-item und am Produktnamen
   (.cart-item__name) das Attribut data-ms-kit-note (Bestandteile), das CSS
   zeigt es als Zeile unter dem Namen an.

   Konfiguration kommt aus snippets/ms-anbau-garantie.liquid (window.msAnbauGarantie).
*/
(function () {
  'use strict';

  var config = window.msAnbauGarantie || {};
  var GIFT_ID = Number(config.giftVariantId || 0);
  var GIFT_HANDLE = config.giftHandle || '';
  var KIT_NOTE = config.kitNote || '';
  var TRIGGERS = (config.triggerVariantIds || []).map(Number).filter(Boolean);
  if (!GIFT_ID || !TRIGGERS.length || !window.fetch) return;

  var nativeFetch = window.fetch.bind(window);
  var routes = window.routes || {};
  var ADD_URL = routes.cart_add_url || '/cart/add';
  var CHANGE_URL = routes.cart_change_url || '/cart/change';
  var CART_URL = routes.cart_url || '/cart';
  var RELOAD_FLAG = 'msGarantieReload';

  var busy = false;
  var queued = false;
  var moving = false;
  var timer = null;

  function post(url, data) {
    return nativeFetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    });
  }

  function getCart() {
    return nativeFetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function isTrigger(id) {
    return TRIGGERS.indexOf(Number(id)) !== -1;
  }

  /* Liest die Varianten-IDs aus einem Add-Request, egal in welchem Format */
  function idsFromBody(body) {
    var ids = [];
    function collect(key, value) {
      if (key === 'id' || /^items\[\d+\]\[id\]$/.test(key)) ids.push(value);
    }
    try {
      if (!body) return ids;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        body.forEach(function (value, key) { collect(key, value); });
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        body.forEach(function (value, key) { collect(key, value); });
      } else if (typeof body === 'string') {
        var trimmed = body.replace(/^\s+/, '');
        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          var data = JSON.parse(trimmed);
          var list = data && data.items ? data.items : [data];
          for (var i = 0; i < list.length; i++) {
            if (list[i] && list[i].id != null) ids.push(list[i].id);
          }
        } else {
          new URLSearchParams(body).forEach(function (value, key) { collect(key, value); });
        }
      }
    } catch (e) {}
    return ids;
  }

  function ensureGiftFirst() {
    return getCart()
      .then(function (cart) {
        var present = (cart.items || []).some(function (item) { return item.variant_id === GIFT_ID; });
        if (present) return null;
        return post(ADD_URL, { items: [{ id: GIFT_ID, quantity: 1 }] });
      })
      .catch(function () { return null; });
  }

  function sync() {
    return getCart().then(function (cart) {
      var gift = null;
      var hasTrigger = false;
      (cart.items || []).forEach(function (item) {
        if (item.variant_id === GIFT_ID) gift = item;
        if (isTrigger(item.variant_id)) hasTrigger = true;
      });

      if (hasTrigger && !gift) {
        return post(ADD_URL, { items: [{ id: GIFT_ID, quantity: 1 }] }).then(function () { return true; });
      }
      if (hasTrigger && gift && gift.quantity !== 1) {
        return post(CHANGE_URL, { id: gift.key, quantity: 1 }).then(function () { return true; });
      }
      if (!hasTrigger && gift) {
        return post(CHANGE_URL, { id: gift.key, quantity: 0 }).then(function () { return true; });
      }
      return false;
    });
  }

  function onCartPage() {
    var here = window.location.pathname.replace(/\/+$/, '');
    var cart = CART_URL.replace(/\/+$/, '');
    return here === cart;
  }

  function reloadOnce() {
    try {
      if (window.sessionStorage.getItem(RELOAD_FLAG) === '1') return;
      window.sessionStorage.setItem(RELOAD_FLAG, '1');
    } catch (e) {}
    window.location.reload();
  }

  function clearReloadFlag() {
    try { window.sessionStorage.removeItem(RELOAD_FLAG); } catch (e) {}
  }

  function refreshCartPage() {
    return nativeFetch(CART_URL + '?section_id=cart-items')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var source = doc.querySelector('cart-items');
        var target = document.querySelector('cart-items');
        if (!source || !target) throw new Error('cart section missing');
        target.replaceWith(source);
        mark();
      })
      .catch(function () { reloadOnce(); });
  }

  function refreshBubble() {
    nativeFetch(window.location.pathname + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var source = doc.querySelector('.shopify-section') || doc.body;
        var target = document.querySelector('#cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      })
      .catch(function () {});
  }

  function refresh() {
    if (onCartPage()) {
      refreshCartPage();
      refreshBubble();
      return;
    }
    var items = document.querySelector('cart-drawer-items');
    if (items && typeof items.onCartUpdate === 'function') {
      try { items.onCartUpdate(); } catch (e) {}
    }
    refreshBubble();
  }

  function unlink(row) {
    var links = row.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (href.indexOf('/products/') !== -1 || (GIFT_HANDLE && href.indexOf(GIFT_HANDLE) !== -1)) {
        links[i].removeAttribute('href');
        links[i].removeAttribute('target');
        links[i].setAttribute('role', 'text');
      }
    }
  }

  function rowFor(scope, variantId) {
    var node = scope.querySelector('[data-variant-id="' + variantId + '"], [data-quantity-variant-id="' + variantId + '"]');
    var row = node && node.closest ? node.closest('.cart-item') : null;
    return row && row.parentNode === scope ? row : null;
  }

  function reorder() {
    var gifts = document.querySelectorAll('.cart-item.ms-garantie-item');
    for (var i = 0; i < gifts.length; i++) {
      var gift = gifts[i];
      var scope = gift.parentNode;
      if (!scope) continue;
      var trigger = null;
      for (var t = 0; t < TRIGGERS.length; t++) {
        var candidate = rowFor(scope, TRIGGERS[t]);
        if (candidate) trigger = candidate;
      }
      if (trigger && trigger !== gift && trigger.nextElementSibling !== gift) {
        moving = true;
        try {
          if (trigger.after) { trigger.after(gift); }
          else { scope.insertBefore(gift, trigger.nextSibling); }
        } catch (e) {}
        moving = false;
      }
    }
  }

  function markKit() {
    if (!KIT_NOTE) return;
    for (var t = 0; t < TRIGGERS.length; t++) {
      var nodes = document.querySelectorAll('[data-variant-id="' + TRIGGERS[t] + '"], [data-quantity-variant-id="' + TRIGGERS[t] + '"]');
      for (var i = 0; i < nodes.length; i++) {
        var row = nodes[i].closest ? nodes[i].closest('.cart-item') : null;
        if (!row) continue;
        row.classList.add('ms-kit-item');
        var name = row.querySelector('.cart-item__name');
        if (name && name.getAttribute('data-ms-kit-note') !== KIT_NOTE) {
          name.setAttribute('data-ms-kit-note', KIT_NOTE);
        }
      }
    }
  }

  function mark() {
    var nodes = document.querySelectorAll('[data-variant-id="' + GIFT_ID + '"], [data-quantity-variant-id="' + GIFT_ID + '"]');
    for (var i = 0; i < nodes.length; i++) {
      var row = nodes[i].closest ? nodes[i].closest('.cart-item') : null;
      if (!row) continue;
      row.classList.add('ms-garantie-item');
      unlink(row);
    }
    markKit();
    reorder();
  }

  function reconcile() {
    if (busy) { queued = true; return; }
    busy = true;
    sync()
      .then(function (changed) {
        busy = false;
        if (queued) { queued = false; reconcile(); return; }
        if (changed) { refresh(); } else { clearReloadFlag(); }
        mark();
      })
      .catch(function () { busy = false; });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(reconcile, 150);
  }

  window.fetch = function () {
    var args = arguments;
    var url = '';
    var method = 'GET';
    var body = null;
    try {
      var input = args[0];
      var init = args[1];
      url = typeof input === 'string' ? input : (input && input.url) || '';
      method = (init && init.method) || (input && input.method) || 'GET';
      body = init && init.body !== undefined ? init.body : null;
    } catch (e) {}

    var isPost = String(method).toUpperCase() === 'POST';
    var isAdd = isPost && /\/cart\/add(\.js)?($|\?)/.test(url);
    var isChange = isPost && /\/cart\/(change|update)(\.js)?($|\?)/.test(url);

    if (isAdd) {
      var ids = idsFromBody(body);
      var addsTrigger = false;
      for (var i = 0; i < ids.length; i++) {
        if (isTrigger(ids[i])) addsTrigger = true;
      }
      if (addsTrigger) {
        /* Garantie zuerst anlegen, damit das Starter-Kit die neuere Zeile ist */
        return ensureGiftFirst().then(function () {
          var call = nativeFetch.apply(window, args);
          call.then(function () { schedule(); }).catch(function () {});
          return call;
        });
      }
    }

    var result = nativeFetch.apply(window, args);
    if (isAdd || isChange) {
      result.then(function () { schedule(); }).catch(function () {});
    }
    return result;
  };

  var observer = new MutationObserver(function () {
    if (moving) return;
    mark();
  });

  function start() {
    mark();
    schedule();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
